import { create } from 'zustand'

export type AgentConversationScope = 'general' | 'deliverable_studio' | 'brief_strategist'

type ScopeSlot = {
    activeConversationId: string | null
    isDraftConversation: boolean
}

const emptySlot = (): ScopeSlot => ({
    activeConversationId: null,
    isDraftConversation: false,
})

export type ActiveConversationState = {
    slots: Record<AgentConversationScope, ScopeSlot>
    setActiveConversationId: (scope: AgentConversationScope, id: string | null) => void
    startDraftConversation: (scope?: AgentConversationScope) => void
    selectConversation: (scope: AgentConversationScope, id: string | null) => void
}

export const useAgentConversationStore = create<ActiveConversationState>(set => ({
    slots: {
        general: emptySlot(),
        deliverable_studio: emptySlot(),
        brief_strategist: emptySlot(),
    },
    setActiveConversationId: (scope, id) =>
        set(state => ({
            slots: {
                ...state.slots,
                [scope]: { activeConversationId: id, isDraftConversation: false },
            },
        })),
    startDraftConversation: (scope = 'general') =>
        set(state => ({
            slots: {
                ...state.slots,
                [scope]: { activeConversationId: null, isDraftConversation: true },
            },
        })),
    selectConversation: (scope, id) =>
        set(state => ({
            slots: {
                ...state.slots,
                [scope]: { activeConversationId: id, isDraftConversation: false },
            },
        })),
}))

export function useAgentConversationSlot(scope: AgentConversationScope) {
    return useAgentConversationStore(s => s.slots[scope])
}

export type AgentPanelState = {
    isOpen: boolean
    openPanel: () => void
    closePanel: () => void
    togglePanel: () => void
}

export const useAgentPanelStore = create<AgentPanelState>(set => ({
    isOpen: false,
    openPanel: () => set(() => ({ isOpen: true })),
    closePanel: () => set(() => ({ isOpen: false })),
    togglePanel: () => set(prev => ({ isOpen: !prev.isOpen })),
}))
